import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import './UserForm.css';

// Компонент для отображения индикатора загрузки
const Loading = () => (
    <div className="loading">
        <p>Загрузка...</p>
    </div>
);

// Компонент для отображения сообщения об ошибке
const ErrorMessage = ({ message }) => (
    <div className="error-message">
        <p>{message}</p>
    </div>
);

const UserForm = ({ user, onUserUpdated, onClose }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (user) {
            setUsername(user.username);
            setEmail(user.email);
            setFirstName(user.firstName || '');
            setLastName(user.lastName || '');
        }
    }, [user]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        try {
            const userData = {
                username,
                email,
                firstName: firstName || undefined,
                lastName: lastName || undefined,
            };

            if (user) {
                // Используем PATCH для редактирования
                await api.patch(`/users/${user.id}`, userData);
            } else {
                // Для создания нового пользователя
                await api.post('/users', { ...userData, password });
            }

            onUserUpdated(); // Обновление списка пользователей после изменений
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="userform-container">
            <div className="userform-modal">
                <div className="userform-header">
                    <h2>{user ? 'Редактировать пользователя' : 'Добавить пользователя'}</h2>
                    <button className="userform-close-btn" onClick={onClose}>X</button>
                </div>
                {isLoading && <Loading />}
                {error && <ErrorMessage message={error.message || 'Произошла ошибка'} />}
                <form onSubmit={handleSubmit} className="userform-body">
                    <div className="userform-group">
                        <label htmlFor="username">Имя пользователя:</label>
                        <input
                            className="userform-input"
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="userform-group">
                        <label htmlFor="email">Email:</label>
                        <input
                            className="userform-input"
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="userform-group">
                        <label htmlFor="firstName">Имя:</label>
                        <input
                            className="userform-input"
                            type="text"
                            id="firstName"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                    </div>
                    <div className="userform-group">
                        <label htmlFor="lastName">Фамилия:</label>
                        <input
                            className="userform-input"
                            type="text"
                            id="lastName"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                    </div>
                    {!user && (
                        <div className="userform-group">
                            <label htmlFor="password">Пароль:</label>
                            <input
                                className="userform-input"
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    )}
                    <div className="userform-buttons">
                        <button className="userform-btn userform-save-btn" type="submit">
                            {user ? 'Сохранить' : 'Добавить'}
                        </button>
                        <button className="userform-btn userform-cancel-btn" type="button" onClick={onClose}>
                            Отмена
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserForm;
